import { WizardStepPage } from '../WizardStepPage/view';
import { DeviceNameStepView } from './../DeviceNameStepView/view';
import { EquipmentTypeaheadView } from './EquipmentTypeaheadView/view';
import { EquipmentLocationCollection } from '../../../features/mobileForm/ingredientEquipmentTemperatureFields/models';

export const EquipmentStepView = WizardStepPage.extend({
    template: '#tpl_equipment_step',
    stepNumberKey: 'mobile_sensors_wizard_step_one',
    stepTitleKey: 'mobile_sensors_equipment',

    regions: {
        r_equipment_typeahead: '.r_equipment_typeahead'
    },

    events: {
        'click .skip_step': 'skipStep',
        'click .next_step': 'displayNextStep'
    },

    onRender: function () {
        this.displayEquipmentTypeahead();
        this.updateNextButtonState(this._isEnabled());
    },

    _isEnabled: function () {
        return !!this.model.get('equipment_location');
    },

    skipStep: function () {
        this.showNextStep();
    },

    displayEquipmentTypeahead: function () {
        var this_ = this;

        const location = $f.mobile.dashboard.get_active_account_or_group();

        this.r_equipment_typeahead.show(
            new EquipmentTypeaheadView({
                model: this_.model.get('equipment_location'),
                collection: new EquipmentLocationCollection([], {
                    locationId: location.get('id'),
                    excludeEquipmentWithSensorLinked: true
                }),
                post_on_select: function (equipmentLocation) {
                    this_.model.set('equipment_location', equipmentLocation);
                    this_.render();
                },

                on_clear: function () {
                    this_.model.set('equipment_location', null);
                    this_.render();
                }
            })
        );
    },

    displayNextStep: function () {
        if (this._isEnabled()) {
            this.showNextStep();
        }
    },

    showNextStep: function () {
        $f.mobile.nav.show(DeviceNameStepView, {
            model: this.model,
            stepNumberKey: this.nextStepNumberKey,
            selectedManufacturer: this.selectedManufacturer
        });
    }
});
